module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter1",
    attrs: {
      "id": "pgepubid00007"
    }
  }, [_c('h2', {
    staticClass: "c4"
  }, [_vm._v("NATURAL ASTROLOGY")])]), _vm._v(" "), _c('p', {
    staticClass: "c10"
  }, [_vm._v("Is confined to the study of exploring natural effects,\nas "), _c('span', {
    staticClass: "fss"
  }, [_vm._v("CHANGE OF WEATHER")]), _vm._v(", "), _c('span', {
    staticClass: "fss"
  }, [_vm._v("WINDS")]), _vm._v(", "), _c('span', {
    staticClass: "fss"
  }, [_vm._v("STORMS")]), _vm._v(",\n"), _c('span', {
    staticClass: "fss"
  }, [_vm._v("HURRICANES")]), _vm._v(", "), _c('span', {
    staticClass: "fss"
  }, [_vm._v("THUNDER")]), _vm._v(", "), _c('span', {
    staticClass: "fss"
  }, [_vm._v("FLOODS")]), _vm._v(", "), _c('span', {
    staticClass: "fss"
  }, [_vm._v("EARTHQUAKES")]), _vm._v(",\nand the like. In this sense it is admitted\nto be a part of natural philosophy. It was\nunder this view that Mr. Goad, Mr. Boyle, and\nDr. Mead, pleaded for its use. The first endeavours\nto account for the diversity of seasons from\nthe situations, habitudes, and motions of the planets;\nand to explain an infinity of phenomena by\nthe contemplation of the stars. The Honourable\nMr. Boyle admitted, that all physical bodies are\ninfluenced by the heavenly bodies; and the\n"), _c('span', {
    attrs: {
      "id": "Page_27",
      "title": "27"
    }
  }), _vm._v("Doctor’s opinion, in his treatise concerning the\n"), _c('span', {
    staticClass: "sc"
  }, [_vm._v("Power of the Sun and Moon")]), _vm._v(", &c. is in favour\nof the doctrine. But these predictions and\ninfluences are ridiculed and entirely exploded by\nthe most esteemed modern philosophers, of which\nthe reader may have a learned specimen in "), _c('span', {
    staticClass: "sc"
  }, [_vm._v("Rohault’s")]), _vm._v(" "), _c('em', {
    staticClass: "calibre12"
  }, [_vm._v("Tract. Physic.")]), _vm._v(" pt. ii. c. 27.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a58ec006","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/Section0008.vue
// module id = 78
// module chunks = 0